<!-- <div class="main__container" [class.collapsed]="isCollapsed">
  <section class="sidebar">
    <app-sidebar (toggleSidebar)="toggleSidebar()"></app-sidebar>
  </section>

  <section class="content">
    <nav>
      <app-navbar></app-navbar>
    </nav>
    <router-outlet></router-outlet>
  </section>

</div>
 -->

<!--
  Un dominio de un nivel de marcas que no está asignado a ninguna NO sirve la
  suite: el aviso REEMPLAZA al shell completo (outlet incluido) en lugar de
  navegar, así que el bloqueo no depende de la ruta de entrada (R8).
-->
@if (dominioNoAsignado()) {
  <app-unassigned-domain-notice />
} @else {
  <div *ngIf="(geo.estadoPermiso$ | async) === 'granted'; else bloqueado">
    <router-outlet></router-outlet>
  </div>

  <ng-template #bloqueado>
    <div style="text-align: center; margin-top: 50px;">
      </div>
  </ng-template>

  @defer (on idle) {
    @if (pushNotificationComponent) {
      <ng-container *ngComponentOutlet="pushNotificationComponent" />
    }
  }
}
